import axios from 'axios';
let serve = axios.create({
  //配置基地址
  baseURL: 'https://event.kongquechao.com',
})

export default serve
